




































import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Resource } from '@/modules/backend/Entities/Resource';
import { CreateRateData } from '@/modules/backend/Dto/CreateRateData';
import { RatesModule } from '@/store/dashboard/rates/RatesModule';
import { resolveModule } from '@/store';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { ValidationObserver } from '@/plugins/vee-validate';

const ResourceModule = namespace('dashboard/resources');

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class RateAddDialog extends Mixins(Mixin) {
  private readonly ratesModule: RatesModule = resolveModule(RatesModule);

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  @ResourceModule.Action('Fetch')
  private readonly fetchResources!: () => Promise<void>;

  @ResourceModule.Getter('Resources')
  private readonly getResources!: Resource[];

  private get resources(): Resource[] {
    return this.getResources || [];
  }

  @Prop({
    required: false,
    type: Number,
    default: undefined
  })
  private readonly buildingId?: number;

  @Prop({
    required: false,
    type: Number,
    default: undefined
  })
  private readonly accountId?: number;

  private createRate: CreateRateData = {
    resourceId: -1,
    buildingId: this.buildingId,
    accountId: this.accountId,
    price: 0
  };

  private async add(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      await this.ratesModule.create({
        ...this.createRate,
        price: Number(this.createRate.price)
      });
    } else {
      throw new Error('Validation error');
    }
  }

  private async dialogOpenHandler(): Promise<void> {
    this.clearForm();

    await this.fetchResources();
  }

  private clearForm(): void {
    this.observer.reset();
    this.createRate = {
      resourceId: -1,
      buildingId: this.buildingId,
      accountId: this.accountId,
      price: 0
    };
  }
}
